export const ToothIcon = ({ size = 24, strokeWidth = 1.6, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M16.5 2.5c-1.6 0-2.5.9-4.5.9s-2.9-.9-4.5-.9C5 2.5 3.5 4 3.5 7c0 1.9.4 3.5.9 5.4.3 1.1.5 2.2.7 3.6.2 1.4.4 2.7.8 3.7.4 1 1 1.8 1.9 1.8.9 0 1.5-.7 1.9-1.7l1-2.7c.3-.9.8-1.6 1.8-1.6s1.5.7 1.8 1.6l1 2.7c.4 1 1 1.7 1.9 1.7s1.5-.8 1.9-1.8c.4-1 .6-2.3.8-3.7.2-1.4.4-2.5.7-3.6.5-1.9.9-3.5.9-5.4 0-3-1.5-4.5-4-4.5z" />
  </svg>
);
